export default {
  getSkillItem: (state) => state.skillItem,
};
